import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigation } from "../../../../../hooks/useNavigation";

interface TermsDialogProps {
  onClose: () => void;
}

const DEFAULT_TERMS_AND_CONDITIONS_URL = "/Terms-and-Conditions.html";
const UK_TERMS_AND_CONDITIONS_URL = "/en-gb/Terms-and-Conditions.html";

const TermsAndConditionsDialog: React.FC<TermsDialogProps> = ({ onClose }) => {
  const { t } = useTranslation();
  const { lltsBranchId } = useNavigation();
  const termsAndConditionsUrl =
    lltsBranchId === "en-gb" ? UK_TERMS_AND_CONDITIONS_URL : DEFAULT_TERMS_AND_CONDITIONS_URL;

  return (
    <Dialog open={true} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{t("terms.title")}</DialogTitle>
      <DialogContent dividers sx={{ padding: 0, height: "60vh", overflow: "hidden" }}>
        <Box
          component="iframe"
          src={termsAndConditionsUrl}
          sx={{
            width: "100%",
            height: "100%",
            border: "none",
            padding: "16px"
          }}
          title={t("terms.title")}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {t("terms.close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TermsAndConditionsDialog;
